import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkApprovalModal = ({ isOpen, selectedCount, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden border border-border">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-warning/20">
              <Icon name="AlertTriangle" size={24} className="text-warning" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                Bulk Approve Refunds
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                You are about to approve <span className="font-semibold text-foreground">{selectedCount}</span> refund request{selectedCount > 1 ? 's' : ''}.
              </p>
            </div>
          </div>

          <div className="p-4 bg-info/10 border border-info/20 rounded-md mb-6">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} className="text-info flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-info font-body">
                  Bulk approval will:
                </p>
                <ul className="text-xs text-muted-foreground font-caption space-y-1 ml-4 list-disc">
                  <li>Process all selected refunds immediately</li>
                  <li>Send confirmation emails to customers</li>
                  <li>Create audit trail entries</li>
                  <li>Update payment gateway records</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="success"
              size="lg"
              onClick={onConfirm}
              iconName="CheckCircle"
              iconPosition="left"
              fullWidth
            >
              Approve All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkApprovalModal;